export const SHOP_TAB = {
  promo: "promo-orders",
  instore: "instore",
} as const;

export type ShopTab = (typeof SHOP_TAB)[keyof typeof SHOP_TAB];

export const TAB_LABELS: Record<ShopTab, string> = {
  [SHOP_TAB.promo]: "Promo orders",
  [SHOP_TAB.instore]: "Instore orders",
};
